"use strict";

PF.Field.Phone = class Phone extends PF.Field.String
	{
	static get options()
		{
		return {
			fixLength: 10,
			errors: {
				fixLength: (c) => `Номер должен состоять из 10 цифр`,
			}
		};
		}

	init()
		{
		super.init();

		this.onChange('focus', () => this.displayValue = this.calcDisplayValue(this.model.get(this.key)));
		}

	mediateDisplayValue(displayValue)
		{
		if (displayValue === null || displayValue === undefined)
			{
			return '+7 ';
			}
		let value = displayValue;
		value = value.replace(/\+7/, '');
		value = value.replace(/\D/g, '');

		return this.formatPhone(value);
		}


	calcDisplayValue(realValue)
		{
		if (realValue === null || realValue === undefined)
			{
			realValue = '';
			}

		return this.formatPhone(realValue);
		}

	calcRealValue(displayValue)
		{

		let value = displayValue;
		value = value.replace(/\+7/, '');
		value = value.replace(/\D/g, '');
		value = value.substr(0, 10);

		return value;
		}

	formatPhone(value)
		{
		value = value.substr(0, 10);

		if (value.length > 3)
			{
			value = value.substr(0, 3) + ' ' + value.substr(3, value.length);
			}
		if (value.length > 7)
			{
			value = value.substr(0, 7) + ' ' + value.substr(7, value.length);
			}
		if (value.length > 10)
			{
			value = value.substr(0, 10) + ' ' + value.substr(10, value.length);
			}
		value = '+7 ' + value;


		if (!this.focus && value === '+7 ')
			{
			value = '';
			}

		return value;
		}

	};


